<template>
  <v-container fluid>
    <manage-user-role ref="manageUserRoleRef" />
    <v-row>
      <v-col class="flex space-x-2.5 mb-0" cols="12">
        <div v-for="(item, index) in items" :key="index" lg="1" cols="2" align-self="start">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on" fab large dark @click="item.click">
                <v-icon v-text="item.icon"></v-icon>
              </v-btn>
            </template>
            <span>{{ item.tooltip }}</span>
          </v-tooltip>
        </div>
        <v-spacer></v-spacer>
        <div lg="1" cols="2" align-self="center" justify-self="center" @click="addNewRole">
          <v-btn color="primary">
            ADD ROLE
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-card>
      <v-toolbar color="primary" dense flat dark>
        <v-card-title>Manage Users</v-card-title>
      </v-toolbar>
      <v-card-text>
        <index-user ref="indexUserRef" @edit-role="editUserRole" @refetch="refetchUserList" @edit="editUser" />
      </v-card-text>
    </v-card>
    <v-dialog v-model="createDialog" eager max-width="400">
      <v-card class="mx-auto">
        <v-toolbar color="primary" dark>
          <v-card-title>Create User</v-card-title>
        </v-toolbar>
        <v-card-text>
          <create-user :propUserId="userData.id" :propUserData="userData" @close-dialog="userStoreSuccess" />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editDialog" eager max-width="400">
      <v-card class="mx-auto">
        <v-toolbar color="primary" dark>
          <v-card-title>Edit User</v-card-title>
        </v-toolbar>
        <v-card-text>
          <edit-user :propUserId="userData.id" :propUserData="userData" @saved="refetchUserList"
            @close-dialog="editDialog = false" />
        </v-card-text>
      </v-card>
    </v-dialog>
    <manage-role ref="manageRoleRef"></manage-role>
  </v-container>
</template>

<script>
import { useWatchEffect } from '../../../../lib/utils'
import { fetchUsers } from '../../mixins/users.mixin'


const [watchEffect, clearWatchEffect] = useWatchEffect()

export default {
  name: 'vUser',
  components: {
    indexUser: () => import('./components/user/Index'),
    editUser: () => import('./components/user/Edit'),
    createUser: () => import('./components/user/Create'),
    manageUserRole: () => import('./components/user/ManageUserRole'),
    manageRole: () => import('./components/user/ManageRole'),
  },
  data() {
    return {
      createDialog: false,
      editDialog: false,
      userData: {
        id: null,
        name: null,
        username: null,
        email: null,
        active: null,
      },
      items: [
        {
          icon: 'mdi-arrow-left',
          tooltip: 'Previous Page',
          click: () => {
            this.$router.go(-1)
          },
        },
        {
          icon: 'mdi-account-plus',
          tooltip: 'Add User',
          click: () => {
            this.createDialog = true
          },
        },
      ],
    }
  },
  mounted() {
    this.fetchUsers()
  },
  destroyed() {
    clearWatchEffect()
  },
  methods: {
    editUser(item) {
      this.editDialog = true
      this.userData = item
    },
    editUserRole(item) {
      this.$refs.manageUserRoleRef?.getUserRoles(item)
    },
    fetchUsers() {
      watchEffect((onCleanUp) => {
        const controller = new AbortController()
        onCleanUp(() => {
          controller.abort()
        })
        this.$refs?.indexUserRef?.fetchUsers?.(controller)
      }, 'useStoreSuccessWatchEffect')
    },
    refetchUserList() {
      this.fetchUsers()
    },
    userStoreSuccess() {
      this.createDialog = false
      this.fetchUsers()
    },
    addNewRole() {
      this.$refs.manageRoleRef.open()
    },
  },
}
</script>
